import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AtxNavService } from './services';
import { AtxNavComponent } from './components';
import { AtxRouterTabsModule } from '../../other';
import { AtxLocationModule } from '../../other/locations';

@NgModule({
    imports: [
        CommonModule,
        AtxLocationModule,
        AtxRouterTabsModule,
    ],
    declarations: [
        AtxNavComponent,
    ],
    providers: [
        AtxNavService,
    ],
    exports: [
        AtxNavComponent,
    ],
})

export class AtxNavModule {}
